import React, { useEffect, useState } from 'react';
import { Box, Button, Card, TextField } from '@mui/material';
import { isValidEmail } from '../../Utils';
import toast from 'react-hot-toast';
import { useEmailEntryStore } from '../../zustandStore/store.emailentry';

type DiscountBuyers = {
  email: string;
}


interface EmailEntryProps {
  onAdd?: (emails: string[]) => void;
  onRemove?: (email: string) => void;
  list?: any[];

}

export const EmailEntry = (props: EmailEntryProps) => {
  const { onAdd} = props;
  const {addEmails, removeEmail,setEmail, emails, addEmail: pushEmail} = useEmailEntryStore(state => state);
  const [buyers, setBuyers] = useState<string[]> (emails);
  const [textEmail, setTextEmail] = useState<string>('');



  useEffect(() => {
    onAdd(buyers);
  }, [buyers.length]);

  const addEmail = () => {
    textEmail.split(',').forEach(email => {
      if(isValidEmail(email.trim())){
        const trimmedEmail = email.trim();
        if (trimmedEmail && !buyers.includes(trimmedEmail)) {
          setBuyers(prev => [...prev, trimmedEmail]);
          pushEmail(trimmedEmail)
        }
      }else{
        toast.error(`${email} is not a valid email address`);
        setBuyers(prev => prev.filter(e => e !== email));
        removeEmail(email);


      }

    });

  };


  return (
    <Card sx={{
      p: '2%'
    }}>

      <Box sx={{
        px: '1.4%'
      }}>
        <h3>Enter Buyer's email</h3>
        <TextField sx={{
          padding: '0.5%',
          borderRadius: '4px'
        }}
                   value={textEmail} onChange={e => setTextEmail(e.target.value)} />
        <Button onClick={e => {
          addEmail();
          setTextEmail('');
        }}>Add Entry</Button>
      </Box>
      <Box sx={{
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
        mt: '2%'
      }}>
        {buyers.map((email, index) => (
          <Box key={index} sx={{
            display: 'inline-block',
            p: '1%',
            m: '1%',
            borderRadius: '4px'
          }}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              border: '1px solid #ccc',
              borderRadius: '4px',
              padding: '2%'
            }}>
              {email}
              <Button sx={{ ml: '2%' }} color="error" onClick={e => {
                setBuyers(prev => prev.filter(e => e !== email));
                removeEmail(email); // Remove from the store
                props.onRemove && props.onRemove(email);
              }}>Remove</Button>
            </Box>
          </Box>
        ))}

      </Box>

    </Card>
  );
};